import React from 'react';
import { normalizeFeatureValue } from '../../utils/featureNormalization';
import { sortFeatureValues } from '../../utils/sortingUtils';
import { getFeatureCardLayout } from '../../utils/valuePresentation';
import { ValueCardContent } from './ValueCardContent';

const ValueCards = ({ feature, value, onChange, disabled = false, isOptionDisabled, className = '' }) => {
    const schema = feature?.valueSchema || feature?.property?.valueSchema || [];
    const layout = getFeatureCardLayout(feature);
    const values = sortFeatureValues((feature?.values || []).map(normalizeFeatureValue));
    const currentValue = value === undefined || value === null ? '' : String(value);

    if (!values.length) {
        return <div style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>No options available</div>;
    }

    return (
        <div className={className} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {values.map(item => {
                const valKey = String(item.value ?? '');
                const selected = valKey === currentValue;
                const optionDisabled = disabled || Boolean(isOptionDisabled?.(valKey));

                return (
                    <button
                        key={item.id || valKey}
                        type="button"
                        disabled={optionDisabled}
                        onClick={() => !optionDisabled && onChange?.({ target: { value: valKey } })}
                        style={{
                            display: 'block',
                            width: '100%',
                            textAlign: 'left',
                            padding: '1rem',
                            borderRadius: '12px',
                            border: selected ? '2px solid var(--accent)' : '1px solid var(--border)',
                            background: 'var(--bg-card, var(--bg-primary))',
                            cursor: optionDisabled ? 'not-allowed' : 'pointer',
                            opacity: optionDisabled ? 0.5 : 1
                        }}
                    >
                        <ValueCardContent value={item} schema={schema} layout={layout} feature={feature} />
                    </button>
                );
            })}
        </div>
    );
};

export default ValueCards;
